import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Slide from '@mui/material/Slide'; // Import Slide for the smooth closing transition

// Slide direction for smoother exit
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function ForgotPassword({ open, handleClose, signInMethod }) {
  const [inputValue, setInputValue] = React.useState('');
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);

  const handleInputChange = (event) => {
    let value = event.target.value;
    setInputValue(value);

    // WhatsApp validation logic
    if (signInMethod === 'whatsapp') {
      value = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters

      if (value.length > 0 && !value.startsWith('08')) {
        value = '08' + value.slice(2);
      }

      if (value.length < 2) {
        value = '08';
      }

      setInputValue(value);

      if (!value.startsWith('08')) {
        setError('Nomor WhatsApp harus diawali dengan 08');
      } else if (!/^\d+$/.test(value)) {
        setError('Nomor WhatsApp hanya boleh mengandung angka');
      } else {
        setError('');
      }
    } else if (signInMethod === 'email') {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(value)) {
        setError('Masukkan email yang valid');
      } else {
        setError('');
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (signInMethod === 'whatsapp') {
      if (!inputValue.startsWith('08') || !/^\d+$/.test(inputValue)) {
        setError('Nomor WhatsApp tidak valid');
        return;
      }
      console.log("Sending reset link to WhatsApp: " + inputValue);
    } else if (signInMethod === 'email') {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(inputValue)) {
        setError('Masukkan email yang valid');
        return;
      }
      console.log("Sending reset link to email: " + inputValue);
    }

    setLoading(true);
    setError('');

    setTimeout(() => {
      setLoading(false);
      setIsSuccess(true);
    }, 2000);
  };

  const handleCloseDialog = () => {
    setIsSuccess(false);
    setInputValue('');
    setError('');
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
        sx: { backgroundImage: 'none' },
      }}
      TransitionComponent={Transition} // Apply the transition here
      onExited={() => {
        // Reset the state once the dialog has completely closed
        setIsSuccess(false);
        setInputValue('');
        setError('');
      }}
    >
      <DialogTitle>Kirim kata sandi</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          {isSuccess
            ? `Kami telah mengirimkan kata sandi Anda ke ${inputValue}`
            : `Masukkan ${signInMethod === 'email' ? 'email' : 'nomor WhatsApp'} Anda, kami akan mengirimkan kata sandi Anda.`
          }
        </DialogContentText>

        {loading ? (
          <CircularProgress sx={{ alignSelf: 'center' }} />
        ) : (
          !isSuccess && (
            <FormControl fullWidth error={!!error}>
              <OutlinedInput
                autoFocus
                required
                margin="dense"
                id={signInMethod === 'email' ? "email" : "whatsapp"}
                name={signInMethod === 'email' ? "email" : "whatsapp"}
                label={signInMethod === 'email' ? "Email address" : "Nomor WhatsApp"}
                placeholder={signInMethod === 'email' ? "Email address" : "Nomor WhatsApp"}
                type={signInMethod === 'email' ? "email" : "text"}
                value={inputValue}
                onChange={handleInputChange}
                disabled={loading}
              />
              {error && <FormHelperText>{error}</FormHelperText>}
            </FormControl>
          )
        )}
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        {!loading && !isSuccess && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Button onClick={handleCloseDialog} disabled={loading}>
              Cancel
            </Button>
            <Button variant="contained" type="submit" disabled={loading}>
              Submit
            </Button>
          </Box>
        )}
        {isSuccess && (
          <Button variant="contained" onClick={handleCloseDialog}>
            Tutup
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  signInMethod: PropTypes.string.isRequired,
};

export default ForgotPassword;
